



























































































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { PrivateWorker } from '@/types/user'
import PatientSearchField, {
  PatientListItem
} from '@/components/manageOrganization/PatientSearchField.vue'
import { Worker } from '@/types/user.ts'
import ky from 'ky'

@Component({
  components: {
    PatientSearchField,
    Loading: () => import('@/components/common/loadings/Index.vue'),
    Modal: () => import('@/components/common/modals/Modal.vue'),
    HdSetting: () => import('@/views/tabs/hdTabs/Setting.vue')
  }
})
export default class TeamMemberSearch extends Vue {
  $store!: ExStore

  selectWorkers: { [id: number]: boolean } = {}
  searchPatientName = ''
  currentPatient: PatientListItem | null = null
  requestPending = false
  HdSettingModalOpened = false

  editingWorker: Worker | null = null

  get myWorkerInfo() {
    return this.$store.getters['user/workerInfo'] as PrivateWorker
  }

  get teamMembers() {
    return this.$store.getters['team/teamMembers']
  }

  get teamComposition() {
    return this.teamMembers.reduce((composition, { worker }) => {
      return Object.assign(composition, {
        [worker.occupation.code]: (composition[worker.occupation.code] || 0) + 1
      })
    }, {} as { [occupation: string]: number })
  }

  get occupationDict() {
    return this.$store.getters['occupation/occupationDict']
  }

  get currentPatientLocalId() {
    if (!this.currentPatient) {
      return ''
    }

    const myInstitutionCode = this.myWorkerInfo.institution

    const instinution = this.currentPatient.institutions.find(
      ({ institution }) => institution === myInstitutionCode
    )

    return instinution ? instinution.patientLocalId : ''
  }

  async handleSelectPatient(patient: PatientListItem | null) {
    if (!patient) {
      this.currentPatient = null
      this.$store.commit('team/clearTeamMembers')
      this.$emit('selectPatient', this.currentPatient)
      return
    }

    this.currentPatient = patient
    this.requestPending = true

    try {
      await this.$store.dispatch('team/fetchTeamMembers', {
        patientId: patient.id
      })

      this.$emit('selectPatient', this.currentPatient)

      this.selectWorkers = {}
    } catch (error) {
      //
    } finally {
      this.requestPending = false
    }
  }

  OpenHdSettingModal() {
    this.HdSettingModalOpened = true
  }

  async handleDeleteMembers() {
    if (!this.currentPatient) {
      return
    }

    if (
      !Object.keys(this.selectWorkers).some(
        id => this.selectWorkers[Number(id)]
      )
    ) {
      return
    }

    const members = this.teamMembers
      .filter(({ worker }) => {
        return !this.selectWorkers[worker.id]
      })
      .map(params => ({ ...params, worker: params.worker.id }))

    await this.$store.dispatch('team/putTeamMembers', {
      patientId: this.currentPatient.id,
      params: { members }
    })

    this.selectWorkers = {}
  }

  handleEditStaffnumber(worker: Worker) {
    this.editingWorker = Object.assign({}, worker)
  }

  async handleEditSubmit() {
    if (!this.editingWorker) return
    try {
      this.$api.user.patchWorker({
        workerId: this.editingWorker?.id,
        params: { staffNumber: this.editingWorker.staffNumber }
      })
      if (this.currentPatient) {
        await this.$store.dispatch('team/fetchTeamMembers', {
          patientId: this.currentPatient.id
        })
      }
      this.editingWorker = null
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.$store.dispatch('alert/showErrorResponse', errors)
        return
      }
      console.error(e)
    }
  }

  handleEditClose() {
    this.editingWorker = null
  }

  handleHdSettingModalClose() {
    this.HdSettingModalOpened = false
  }

  created() {
    this.$store.commit('team/clearTeamMembers')
  }
}
